// @ts-nocheck
import React from "react";
import { Router, Route, Switch, Redirect } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import history from "./actions/history";
//import { Switch, Redirect } from 'react-router-dom';
import loadable from '@loadable/component';
import GuestLayout from './components/GuestLayout';
import AuthorizedLayout from './components/AuthorizedLayout';
import AuthOProtectedRoute from './AuthOProtectedRoute';
//import UserLogin from './components/routecomponents/UserLogin';
import LoginOauth from './components/routecomponents/LoginOauth';
import LoginOauthJP from './components/routecomponents/LoginOauthJP';
import Loading from "./components/routecomponents/Loading";
import { AuthOUserProfile } from './components/routecomponents/AuthOUserProfile';



const fallback = <div>loading....</div>;

const FileNotFound = loadable(() => import('./components/routecomponents/FileNotFound'), {
    fallback,
});
const Unauthorized = loadable(() => import('./components/routecomponents/Unauthorized'), {
    fallback,
});
const ForgotPassword = loadable(() => import('./components/routecomponents/ForgotPassword'), {
    fallback,
});
const Home = loadable(() => import('./components/routecomponents/Home'), {
    fallback,
});
const ReeferStatus = loadable(() => import('./components/routecomponents/ReeferStatus'), {
    fallback,
});
const ReeferDetails = loadable(() => import('./components/routecomponents/ReeferDetails'), {
    fallback,
});
const MyProfile = loadable(() => import('./components/routecomponents/MyProfile'), {
    fallback,
});
const GensetStatus = loadable(() => import('./components/routecomponents/GensetStatus'), {
    fallback,
});
const DryStatus = loadable(() => import('./components/routecomponents/DryStatus'), {
    fallback,
});
const GeofenceManagement = loadable(() => import('./components/routecomponents/GeofenceManagement'), {
    fallback,
});
const ReeferCommandStatus = loadable(() => import('./components/routecomponents/ReeferCommandStatusSearch'), {
    fallback,
});
const PreferenceSettings = loadable(() => import('./components/routecomponents/PreferenceSettings'), {
    fallback,
});
const RcdStatus = loadable(() => import('./components/routecomponents/RcdStatus'), {
    fallback,
});

const UserSearch = loadable(() => import('./components/routecomponents/UserSearch').then(m => m.UserSearch), {
    fallback,
});

const CargoCareProfiles = loadable(() => import('./components/routecomponents/CargoCareProfiles').then(m => m.CargoCareProfiles), {
    fallback,
});
const GroupManagement = loadable(() => import('./components/routecomponents/GroupManagement').then(m => m.GroupManagement), {
    fallback,
});
const FleetManagement = loadable(() => import('./components/routecomponents/FleetManagement'), {
    fallback,
});
const AccessDenied = loadable(() => import('./components/routecomponents/AccessDenied'), {
    fallback,
});
const AssetSearch = loadable(() => import('./components/routecomponents/AssetSearch').then(m => m.AssetSearch), {
    fallback,
});
const DeviceSearch = loadable(() => import('./components/routecomponents/DeviceSearch').then(m => m.DeviceSearch), {
    fallback,
});
const SubscriptionManager = loadable(() => import('./components/routecomponents/SubscriptionManager'), {
    fallback,
});
const AdminCargoCareSettings = loadable(() => import('./components/routecomponents/AdminCargoCareSettings'), {
    fallback,
});
const CustomAttributes = loadable(() => import('./components/routecomponents/CustomAttributes'), {
    fallback,
});
const VesselStatus = loadable(() => import('./components/routecomponents/VesselStatus'), {
    fallback,
});
const BookingAssignEdit = loadable(() => import('./components/routecomponents/BookingAssignEdit').then(m => m.BookingAssignEdit), {
    fallback,
});
const NewBookingCreate = loadable(() => import('./components/routecomponents/NewBookingCreate').then(m => m.NewBookingCreate), {
    fallback,
});
const NewBookingEdit = loadable(() => import('./components/routecomponents/NewBookingEdit').then(m => m.NewBookingEdit), {
    fallback,
});
const MenuBookingUnAssign = loadable(() => import('./components/routecomponents/MenuBookingUnAssign').then(m => m.MenuBookingUnAssign), {
    fallback,
});
const ViewBooking = loadable(() => import('./components/routecomponents/ViewBooking').then(m => m.ViewBooking), {
    fallback,
});
const BookingUnAssign = loadable(() => import('./components/routecomponents/BookingUnAssign').then(m => m.BookingUnAssign), {
    fallback,
});
const GensetCommandStatusSearch = loadable(() => import('./components/routecomponents/GensetCommandStatusSearch'), {
    fallback,
});
const GensetDetails = loadable(() => import('./components/routecomponents/GensetDetails'), {
    fallback,
});
const DryCommandStatusSearch = loadable(() => import('./components/routecomponents/DryCommandStatusSearch'), {
    fallback,
});
const DryDetails = loadable(() => import('./components/routecomponents/DryDetails'), {
    fallback,
});
const ReeferSoftwareDistribute = loadable(() => import('./components/routecomponents/ReeferSoftwareDistribute'), {
    fallback,
});
const RCDFirmwareDistribute = loadable(() => import('./components/routecomponents/RCDFirmwareDistribute'), {
    fallback,
});
const GeofenceDistribute = loadable(() => import('./components/routecomponents/GeofenceDistribute'), {
    fallback,
});
const FileRepository = loadable(() => import('./components/routecomponents/FileRepository'), {
    fallback,
});
const ReeferSoftwareFile = loadable(() => import('./components/routecomponents/ReeferSoftwareFile'), {
    fallback,
});
const RcdFirmwareFile = loadable(() => import('./components/routecomponents/RcdFirmwareFile'), {
    fallback,
});
const GeofenceFile = loadable(() => import('./components/routecomponents/GeofenceFile'), {
    fallback,
});
const GensetHistory = loadable(() => import('./components/routecomponents/GensetHistorySearch'), {
    fallback,
});
const GensetMap = loadable(() => import('./components/routecomponents/GensetMapSearch'), {
    fallback,
});

const ManageGenset = loadable(() => import('./components/routecomponents/ManageGenset').then(m => m.ManageGenset), {
    fallback,
});
const ManageDry = loadable(() => import('./components/routecomponents/ManageDry').then(m => m.ManageDry), {
    fallback,
});
const ManageChassis = loadable(() => import('./components/routecomponents/ManageChassis').then(m => m.ManageChassis), {
    fallback,
});
const ManageReefer = loadable(() => import('./components/routecomponents/ManageReefer').then(m => m.ManageReefer), {
    fallback,
});
const DwellTimeReeferReport = loadable(() => import('./components/routecomponents/DwellTimeReeferReport'), {
    fallback,
});
const DryHistory = loadable(() => import('./components/routecomponents/DryHistorySearch'), {
    fallback,
});
const DryMap = loadable(() => import('./components/routecomponents/DryMapSearch'), {
    fallback,
});
const ReeferHistory = loadable(() => import('./components/routecomponents/ReeferHistorySearch'), {
    fallback,
});
const RcdHistory = loadable(() => import('./components/routecomponents/RcdHistorySearch'), {
    fallback,
});
const ReeferMap = loadable(() => import('./components/routecomponents/ReeferMapSearch'), {
    fallback,
});
const DeploymentStatus = loadable(() => import('./components/routecomponents/DeploymentStatus'), {
    fallback,
});
const DeploymentDetails = loadable(() => import('./components/routecomponents/DeploymentDetails').then(m => m.DeploymentDetails), {
    fallback,
});
const DeploymentStatistics = loadable(() => import('./components/routecomponents/DeploymentStatistics').then(m => m.DeploymentStatistics), {
    fallback,
});
const PowerOnOffReport = loadable(() => import('./components/routecomponents/PowerOnOffReport'), {
    fallback,
});
const DwellTimeReport = loadable(() => import('./components/routecomponents/DwellTimeReport'), {
    fallback,
});
const GravityVectorReport = loadable(() => import('./components/routecomponents/GravityVectorReport'), {
    fallback,
});
const FuelGainReport = loadable(() => import('./components/routecomponents/FuelGainReport'), {
    fallback,
});
const FuelLossReport = loadable(() => import('./components/routecomponents/FuelLossReport'), {
    fallback,
});
const ShorePowerReport = loadable(() => import('./components/routecomponents/ShorePowerReport'), {
    fallback,
});
const EngineHourReport = loadable(() => import('./components/routecomponents/EngineHourReport'), {
    fallback,
});
const DwellTimeDryReport = loadable(() => import('./components/routecomponents/DwellTimeDryReport'), {
    fallback,
});
const FeedBack = loadable(() => import('./components/routecomponents/FeedBack'), {
    fallback,
});
const UserGuide = loadable(() => import('./components/routecomponents/UserGuide'), {
    fallback,
});
const ReleaseNotes = loadable(() => import('./components/routecomponents/ReleaseNotes'), {
    fallback,
});
const OktaOINConfigGuide = loadable(() => import('./components/routecomponents/OktaOINConfigGuide'), {
    fallback,
});
const ContactUs = loadable(() => import('./components/routecomponents/ContactUs'), {
    fallback,
});
const ChassisStatus = loadable(() => import('./components/routecomponents/ChassisStatus'), {
    fallback,
});
const ChassisHistory = loadable(() => import('./components/routecomponents/ChassisHistorySearch'), {
    fallback,
});
const ChassisMap = loadable(() => import('./components/routecomponents/ChassisMapSearch'), {
    fallback,
});
const ChassisDetails = loadable(() => import('./components/routecomponents/ChassisDetails'), {
    fallback,
});

const CommandManagement = loadable(() => import('./components/routecomponents/CommandManagement').then(m => m.CommandManagement), {
    fallback,
});


const OAuthJPApp = () => {
    const { isLoading, error } = useAuth0();

    if (error) {
        var preloader = document.getElementById("preloader");
        preloader.classList.add("hidden");
        return <div>Oops... {error.message}   <div className='PageNotFoundText'>Some thing went wrong. Please sign in again.</div></div>;
    }

    if (isLoading) {
        return <Loading />;
    }

    return (
        <Switch>
            <Route layout={GuestLayout} exact path='/JP' component={LoginOauthJP} />
            <AuthOProtectedRoute layout={GuestLayout} path='/authOUserProfile' component={AuthOUserProfile} />
            <Route layout={GuestLayout} path='/fileNotFound' component={FileNotFound} />
            <Route layout={GuestLayout} path='/unauthorized' component={Unauthorized} />
            <Route layout={GuestLayout} path='/forgotpassword' component={ForgotPassword} />
            <Route layout={GuestLayout} path='/AccessDenied' component={AccessDenied} />
            <AuthOProtectedRoute layout={AuthorizedLayout} path='/home' component={Home} />
            <AuthOProtectedRoute layout={AuthorizedLayout} path='/myprofile' component={MyProfile} />
            <AuthOProtectedRoute layout={AuthorizedLayout} path='/reeferdetails' component={ReeferDetails} />
            <AuthOProtectedRoute layout={AuthorizedLayout} path='/reeferstatus' component={ReeferStatus} />
            <AuthOProtectedRoute layout={AuthorizedLayout} path='/gensetstatus' component={GensetStatus} />
            <AuthOProtectedRoute layout={AuthorizedLayout} path='/drystatus' component={DryStatus} />
            <AuthOProtectedRoute layout={AuthorizedLayout} path='/chassisstatus' component={ChassisStatus} />
            <AuthOProtectedRoute layout={AuthorizedLayout} path='/vesselstatus' component={VesselStatus} />
            <AuthOProtectedRoute layout={AuthorizedLayout} path='/geofencemanagement' component={GeofenceManagement} />
            <AuthOProtectedRoute layout={AuthorizedLayout} path='/reefercommands' component={ReeferCommandStatus} />
            <AuthOProtectedRoute layout={AuthorizedLayout} path='/reefercommandstatus' component={ReeferCommandStatus} />
            <AuthOProtectedRoute layout={AuthorizedLayout} path='/preferencesettings' component={PreferenceSettings} />
            <AuthOProtectedRoute layout={AuthorizedLayout} path='/usersearch' component={UserSearch} />
            <AuthOProtectedRoute layout={AuthorizedLayout} path='/cargocareprofiles' component={CargoCareProfiles} />
            <AuthOProtectedRoute layout={AuthorizedLayout} path='/rcdstatus' component={RcdStatus} />
            <AuthOProtectedRoute layout={AuthorizedLayout} path='/groupmanagement' component={GroupManagement} />
            <AuthOProtectedRoute layout={AuthorizedLayout} path='/fleetmanagement' component={FleetManagement} />
            <AuthOProtectedRoute layout={AuthorizedLayout} path='/cargocaresettings' component={AdminCargoCareSettings} />
            <AuthOProtectedRoute layout={AuthorizedLayout} path='/customattributes' component={CustomAttributes} />
            <AuthOProtectedRoute layout={AuthorizedLayout} path='/gensetsearch' component={ManageGenset} />
            <AuthOProtectedRoute layout={AuthorizedLayout} path='/drysearch' component={ManageDry} />
            <AuthOProtectedRoute layout={AuthorizedLayout} path='/chassissearch' component={ManageChassis} />
            <AuthOProtectedRoute layout={AuthorizedLayout} path='/reefersearch' component={ManageReefer} />
            <AuthOProtectedRoute layout={AuthorizedLayout} path='/devicesearch' component={DeviceSearch} />
            <AuthOProtectedRoute layout={AuthorizedLayout} path='/subscriptionmanager' component={SubscriptionManager} />
            <AuthOProtectedRoute layout={AuthorizedLayout} path='/gensetcommandstatus' component={GensetCommandStatusSearch} />
            <AuthOProtectedRoute layout={AuthorizedLayout} path='/gensetdetails' component={GensetDetails} />
            <AuthOProtectedRoute layout={AuthorizedLayout} path='/drycommands' component={DryCommandStatusSearch} />
            <AuthOProtectedRoute layout={AuthorizedLayout} path='/drycommandstatus' component={DryCommandStatusSearch} />
            <AuthOProtectedRoute layout={AuthorizedLayout} path='/drydetails' component={DryDetails} />
            <AuthOProtectedRoute layout={AuthorizedLayout} path='/bookingassign' component={BookingAssignEdit} />
            <AuthOProtectedRoute layout={AuthorizedLayout} path='/bookingunassign' component={BookingUnAssign} />
            <AuthOProtectedRoute layout={AuthorizedLayout} path='/Newbookingassign' component={NewBookingCreate} />
            <AuthOProtectedRoute layout={AuthorizedLayout} path='/NewbookingEdit' component={NewBookingEdit} />
            <AuthOProtectedRoute layout={AuthorizedLayout} path='/ViewBooking' component={ViewBooking} />
            <AuthOProtectedRoute layout={AuthorizedLayout} path='/unassignbooking' component={MenuBookingUnAssign} />
            <AuthOProtectedRoute layout={AuthorizedLayout} path='/reefersoftwaredistribute' component={ReeferSoftwareDistribute} />
            <AuthOProtectedRoute layout={AuthorizedLayout} path='/rcdfirmwaredistribute' component={RCDFirmwareDistribute} />
            <AuthOProtectedRoute layout={AuthorizedLayout} path='/geofencedistribute' component={GeofenceDistribute} />
            <AuthOProtectedRoute layout={AuthorizedLayout} path='/filerepository' component={FileRepository} />
            <AuthOProtectedRoute layout={AuthorizedLayout} path='/deploymentstatus' component={DeploymentStatus} />
            <AuthOProtectedRoute layout={AuthorizedLayout} path='/deploymentdetails' component={DeploymentDetails} />
            <AuthOProtectedRoute layout={AuthorizedLayout} path='/deploymentstatistics' component={DeploymentStatistics} />
            <AuthOProtectedRoute layout={AuthorizedLayout} path='/reefersoftwarefile' component={ReeferSoftwareFile} />
            <AuthOProtectedRoute layout={AuthorizedLayout} path='/rcdfirmwarefile' component={RcdFirmwareFile} />
            <AuthOProtectedRoute layout={AuthorizedLayout} path='/geofencefile' component={GeofenceFile} />
            <AuthOProtectedRoute layout={AuthorizedLayout} path='/gensethistory' component={GensetHistory} />
            <AuthOProtectedRoute layout={AuthorizedLayout} path='/gensetmap' component={GensetMap} />
            <AuthOProtectedRoute layout={AuthorizedLayout} path='/dryhistory' component={DryHistory} />
            <AuthOProtectedRoute layout={AuthorizedLayout} path='/chassishistory' component={ChassisHistory} />
            <AuthOProtectedRoute layout={AuthorizedLayout} path='/chassisdetails' component={ChassisDetails} />
            <AuthOProtectedRoute layout={AuthorizedLayout} path='/chassismap' component={ChassisMap} />
            <AuthOProtectedRoute layout={AuthorizedLayout} path='/drymap' component={DryMap} />
            <AuthOProtectedRoute layout={AuthorizedLayout} path='/reeferhistory' component={ReeferHistory} />
            <AuthOProtectedRoute layout={AuthorizedLayout} path='/rcdhistory' component={RcdHistory} />
            <AuthOProtectedRoute layout={AuthorizedLayout} path='/reefermap' component={ReeferMap} />
            <AuthOProtectedRoute layout={AuthorizedLayout} path='/poweronoff' component={PowerOnOffReport} />
            <AuthOProtectedRoute layout={AuthorizedLayout} path='/gensetdwelltime' component={DwellTimeReport} />
            <AuthOProtectedRoute layout={AuthorizedLayout} path='/gravityvector' component={GravityVectorReport} />
            <AuthOProtectedRoute layout={AuthorizedLayout} path='/gensetfuelgain' component={FuelGainReport} />
            <AuthOProtectedRoute layout={AuthorizedLayout} path='/gensetfuelloss' component={FuelLossReport} />
            <AuthOProtectedRoute layout={AuthorizedLayout} path='/gensetshorepower' component={ShorePowerReport} />
            <AuthOProtectedRoute layout={AuthorizedLayout} path='/gensetenginehour' component={EngineHourReport} />
            <AuthOProtectedRoute layout={AuthorizedLayout} path='/drydwelltime' component={DwellTimeDryReport} />
            <AuthOProtectedRoute layout={AuthorizedLayout} path='/reeferdwelltime' component={DwellTimeReeferReport} />
            <AuthOProtectedRoute layout={AuthorizedLayout} path='/feedback' component={FeedBack} />
            <AuthOProtectedRoute layout={AuthorizedLayout} path='/userguide' component={UserGuide} />
            <AuthOProtectedRoute layout={AuthorizedLayout} path='/releasenotes' component={ReleaseNotes} />
            <AuthOProtectedRoute layout={AuthorizedLayout} path='/oktaoinconfigguide' component={OktaOINConfigGuide} />
            <AuthOProtectedRoute layout={AuthorizedLayout} path='/contactus' component={ContactUs} />
            <AuthOProtectedRoute layout={AuthorizedLayout} path='/commandmanagement' component={CommandManagement} />
            <Redirect to="/fileNotFound" />
        </Switch>
    );
};

export default OAuthJPApp;
